// For data that changes only when a user edits it. Data that changes on its own
// (clicks, stats, events) uses VOLATILE_QUERY_STALE_TIME_MS.
export const QUERY_STALE_TIME_MS = 5 * 60_000;

export const VOLATILE_QUERY_STALE_TIME_MS = 0;
